import { styled } from "@mui/material";

import { DefaultIconButton } from "./defaultIconButton";

const BACKGROUND_COLOR = "#f7d4da";
const COLOR = "#ad1f1f";
const HOVER_BACKGROUND_COLOR = "#f3bebe";
const HOVER_COLOR = "#821717";

export const CloseIconButton = styled(DefaultIconButton)`
    background: ${BACKGROUND_COLOR};
    color: ${COLOR};
    &:hover {
        background: ${HOVER_BACKGROUND_COLOR};
        color: ${HOVER_COLOR};
    }
`;
